import { createContext, useContext } from "react";
import type { UseCase } from "../../../util/useCases";

/**
 * The use case the event-flow booking screens book (the venue screens): `venue`
 * at `/venue/book`, `hall` at `/hall/book` — a sports hall runs the same flow
 * (PO, 2026-10-18). The dialog states it once and every step reads it here, so
 * no step names a use case of its own: the room search, the head count, the
 * event field, the booking window, the payment and the request all carry it.
 *
 * Venue is the default, so a step rendered outside a provider (a test, an
 * older entry) books a venue, as it always did.
 */
export const DEFAULT_EVENT_FLOW_USE_CASE: UseCase = "venue";

const EventFlowUseCaseContext = createContext<UseCase>(DEFAULT_EVENT_FLOW_USE_CASE);

export const EventFlowUseCaseProvider = EventFlowUseCaseContext.Provider;

/** The use case this event-flow screen books. */
export const useEventFlowUseCase = (): UseCase => useContext(EventFlowUseCaseContext);
